import JsonApiObject from '@/_models/JsonApi'

import Log from '@/views/Log/models/log'

import hseDocumentInfo from '@/views/Project/HSE/dialog/hseDocumentInfo/hseDocumentInfo.vue'

export default class HSEDocument extends JsonApiObject {
    public constructor(data: any, included?) {
        super(data, included)
    }

    async showLog(document) {
        await JsonApiObject.openDialog(hseDocumentInfo, { document: document })
    }

    async getLog(projectId: string, timeStamp: any, activityLogNumber = '1') {
        let data = {
            'filter[activityLogEntityId]': projectId,
            'filter[activityLogNumber]': [activityLogNumber],
            'filter[time][lt]': timeStamp,
            'filter[entityId]': this._id,
        }

        let res = await Log.getLog(data)

        return res
    }
}
